// src/pages/Orders/OrdersPage.tsx
import React from 'react';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import OrdersContainer from './containers/GeneralOrderContainer';
import TransportationOrderContainer from './containers/TransportationOrderContainer';
import DefaultCard from '../../components/default/DefaultCard';

const breadcrumbs: BreadcrumbsItem[] = [
  { name: 'Pedidos', url: '/orders', isActive: true }
];

const OrdersPage = () => {
  return (
    <>
      {/* se comenta contenedor de transporte y warehouse, se deja solo contenedor transporte (tarjeta EOBLYD-461) TransportationOrderContainer  */}
      <Breadcrumbs pageSection="Pedidos" breadcrumbs={breadcrumbs} />
      <OrdersContainer />
      {/* <TransportationOrderContainer /> */}
    </>
    
  );
};

export default OrdersPage;
